import React from 'react'
import cn from 'classnames'
import styles from 'components/shared/icons/public-icon.module.scss'
import { Music } from 'lucide-react'

// A music thread's scope mark: PublicIcon's orange circle with a note in place
// of the globe (music threads are public).
export default function MusicIcon(props) {
    const { contextStyles, hoverStyles, selectedStyles } = props
    return (
        <div className={cn(styles.publicIcon, contextStyles, hoverStyles, selectedStyles)}>
            <Music />
        </div>
    )
}
